export const enum VYSION_ACTIONS {
  CLICK = 'click',
  VIEW = 'view',
  ON_FOCUS = 'onFocus',
}
